import { z } from 'zod';
import { uuidSchema } from '../api';
export const INTEGRATION_PROVIDERS = ['nphies', 'wasfaty'];
export const INTEGRATION_ENVIRONMENTS = ['sandbox', 'production'];
export const INTEGRATION_MESSAGE_STATUSES = ['queued', 'sending', 'succeeded', 'rejected', 'failed', 'offline', 'cancelled'];
export const INTEGRATION_MODES = ['realtime', 'queued'];
export const INTEGRATION_LOCAL_TYPES = ['payer', 'charge_item', 'lab_test', 'product', 'diagnosis', 'radiology_study'];
export const saveIntegrationConnectionSchema = z.object({
    enabled: z.boolean().optional(),
    environment: z.enum(INTEGRATION_ENVIRONMENTS).optional(),
    baseUrl: z.string().trim().url().max(300).nullable().optional(),
    settings: z.record(z.string().max(200)).refine((value) => Object.keys(value).length <= 20, 'Too many settings').optional(),
    credentials: z.record(z.string().max(8000)).refine((value) => Object.keys(value).length <= 20, 'Too many credential fields').optional(),
});
export const integrationMessagesQuerySchema = z.object({
    provider: z.enum(INTEGRATION_PROVIDERS).optional(),
    status: z.enum(INTEGRATION_MESSAGE_STATUSES).optional(),
    entityType: z.string().regex(/^[a-z_]{1,60}$/).optional(),
    entityId: uuidSchema.optional(),
    limit: z.coerce.number().int().min(1).max(100).default(30),
    cursor: uuidSchema.optional(),
});
export const integrationCodeMapSchema = z.object({
    provider: z.enum(INTEGRATION_PROVIDERS),
    localType: z.enum(INTEGRATION_LOCAL_TYPES),
    localId: uuidSchema,
    externalSystem: z.string().trim().min(1).max(200),
    externalCode: z.string().trim().min(1).max(80),
    externalDisplay: z.string().trim().max(200).optional(),
});
export const integrationCodeMapsQuerySchema = z.object({
    provider: z.enum(INTEGRATION_PROVIDERS),
    localType: z.enum(INTEGRATION_LOCAL_TYPES).optional(),
    limit: z.coerce.number().int().min(1).max(200).default(100),
    cursor: uuidSchema.optional(),
});
export const nphiesEligibilitySchema = z
    .object({
    patientId: uuidSchema,
    coverageId: uuidSchema.optional(),
    branchId: uuidSchema.optional(),
    mode: z.enum(['validation', 'discovery']).default('validation'),
    payerId: uuidSchema.optional(),
    purposes: z.array(z.enum(['benefits', 'validation', 'discovery'])).min(1).max(3).optional(),
    newborn: z.boolean().default(false),
    transfer: z.boolean().default(false),
    serviceDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
    reuseSession: z.boolean().default(false),
    hasInsuranceButNoPolicy: z.boolean().default(false),
})
    .refine((input) => input.mode !== 'discovery' || Boolean(input.payerId), { path: ['payerId'], message: 'Choose the insurer to ask' });
export const WASFATY_ALTERNATIVE_REASONS = [
    { code: 'AlternativeR01', name: 'Requested strength is not available' },
    { code: 'AlternativeR02', name: 'Requested dosage form is not available' },
    { code: 'AlternativeR03', name: 'Patient cannot swallow tablets or capsules' },
    { code: 'AlternativeR04', name: 'SFDA removed this strength or dosage form from the market' },
    { code: 'AlternativeR05', name: 'Patient prefers or tolerates this dosage form' },
    { code: 'AlternativeR06', name: 'Others' },
];
export const wasfatyDownloadSchema = z.object({
    reference: z.string().trim().min(3).max(60),
    patientIdentity: z.string().trim().min(5).max(30),
});
export const wasfatyAuthorizeSchema = z.object({
    lines: z
        .array(z.object({
        lineNo: z.number().int().min(1).max(200),
        tradeCode: z.string().trim().min(1).max(60),
        packs: z.number().int().min(1).max(10000),
        alternativeReason: z.string().trim().max(40).optional(),
    }))
        .min(1)
        .max(40),
});
export const wasfatyClaimSchema = z.object({
    instructions: z.record(z.string(), z.string().trim().max(500)).optional(),
});
export const wasfatyReleaseSchema = z.object({
    reason: z.string().trim().max(300).optional(),
});
//# sourceMappingURL=integrations.js.map